import { type FC } from "react";
import { Box, type IconProps } from "@chakra-ui/react";
import noop from "lodash/noop";

interface Props extends IconProps {
  Icon: FC<IconProps>;
}

export const SocialIcon: FC<Props> = ({
  Icon,
  href,
  onClick = noop,
  ...props
}) => {
  return (
    <Box
      as="a"
      color="fg-on-accent"
      href={href}
      p={4}
      onClick={onClick}
      rel="noreferrer"
      target="_blank"
      _hover={{ color: "newBrightGreen.100" }}
    >
      <Icon
        color="inherit"
        fill="none"
        height="3rem"
        viewBox="0 0 54 54"
        width="3rem"
        {...props}
      />
    </Box>
  );
};
